<div class="modal-header">
  <h4 class="modal-title">{{ header() }}</h4>
</div>

<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <ng-content select="[modal-body]"/>
  </div>
</div>

<div class="modal-footer justify-content-end">
  <ng-content select="[modal-footer]"/>
</div>
